module.exports = __webpack_public_path__ + "img/rays_divider01.50905ecf.jpg";